import ReducerEntityPrefixTypes from "../../../../../../enums/reducer/reducerEntityPrefixTypes";
import ReducerNamespaceTypes from "../../../../../../enums/reducer/reducerNamespaceTypes";
import { type RootState } from "../../../../../Application/globaltypes/redux";
import { createSearchSlice, type SearchState } from "../../../../../Application/slices/createSearchSlice";

export const initialState: SearchState = {
  term: undefined,
};

const emailSearchSlice = createSearchSlice({
  namePayload: { namespace: ReducerNamespaceTypes.Library, entity: ReducerEntityPrefixTypes.Emails, name: "search" },
  initialState,
  reducers: {},
});

export const { setTerm } = emailSearchSlice.actions;

export const emailSearchSelector = (state: RootState) => state.library.emails.search.term;

export const emailSearchReducer = emailSearchSlice.reducer;
